import React from 'react'
import { Stamp, SantanderLogo } from './style'

export default () =>
    <Stamp>
        Parceiro
        <strong> Santander</strong>
        <SantanderLogo />
    </Stamp>
